import styled from 'styled-components';
import { Button } from '@/components/UI/Button/Button';

export const CollectionsGrid = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fill, minmax(255px, 1fr));

  @media (min-width: 1480px) {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }

  @media (max-width: 1240px) {
    grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 13px;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  }

  @media (max-width: 512px) {
    grid-template-columns: repeat(auto-fill, minmax(166px, 1fr));
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.xsm}) {
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  }
`;

export const AddButton = styled(Button).attrs({
  size: 's',
  appearance: 'primary',
})`
  height: 50px;
  gap: 10px;
  padding: 0 25px;
  font-size: 16px;
  border-radius: 30px;
  box-shadow: 9px 9px 20px 0px ${({ theme }) => theme.palette.overlay[20]};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    gap: 5px;
    height: 36px;
    padding: 0 15px;
    font-size: 13px;
  }
`;

export const FloatingAddButton = styled.div`
  position: sticky;
  bottom: 44px;
  width: max-content;
  z-index: 999;
  left: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    position: fixed;
    left: auto;
    right: 15px;
    bottom: 80px;
  }
`;
